import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, LocaleX, NavX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { VStack, XText } from "IZOX/_X";

/**
 * @augments {Component<Props, State>}
 */
class PPendingToApprove extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    let {history} = this.props;
    this._setAllStates();
    this.timeout = setTimeout(() => {
      GFunc.Logout();
      NavX.Goto(history, "/");
    }, 5000);
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PPendingToApprove.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("Grass")} fullHeight VAlign="-" spacing={20}>
        <XText fontSize={32} color={ColorX.CSS("pureWhite")}>
          {LocaleX.Parse({
            EN: "Your account application is being processed.",
            TC: "您的帳戶申請正在處理中"
          })}
        </XText>
        <XText fontSize={16} color={ColorX.CSS("pureWhite")}>
          {LocaleX.Parse({
            EN: "Please try again later.",
            TC: "請稍後再試。"
          })}
        </XText>
      </VStack>
    );
  }

}

export default observer(PPendingToApprove);
  